import { Model } from "react3l-common";
import { Field } from "react3l-decorators";

export class EmailRemindConfigCalendar extends Model {
  @Field(Number)
  public id?: number;

  @Field(Number)
  public emailReminderConfigId?: number;

  @Field(Number)
  public orderNumber?: number;

  @Field(Number)
  public beforeValue?: number;

  @Field(String)
  public timeUnit?: string;

  @Field(String)
  public description?: string;

  @Field(Number)
  public statusId?: number = 1;

  @Field(String)
  public rowId?: string;

  @Field(Boolean)
  public used?: boolean;
}
